module.exports = __webpack_public_path__ + "img/product-icon1.fae0f6dd.png";